import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { faro } from '@grafana/faro-web-sdk';

import { EnvironmentLoader } from './environments/utils/environment-loader.util';
import { AppModule } from './modules/main/app.module';
import { APP_CONFIG } from './modules/main/providers/app.config';
import { initializeMonitoring } from './modules/monitoring/initialize-monitoring';

EnvironmentLoader.loadEnvironment()
    .then(() => {
        const environment = EnvironmentLoader.environment;
        if (environment.PRODUCTION) {
            enableProdMode();
        }
        initializeMonitoring(environment.MONITORING);
        return platformBrowserDynamic([{ provide: APP_CONFIG, useValue: environment }]).bootstrapModule(AppModule);
    })
    .catch(err => {
        faro.api?.pushError(err instanceof Error ? err : new Error(String(err)));
        console.error(err);
    });
